<script>
    import A from "../lib/Router/A.svelte";
    import AppIcon from "./icons/AppIcon.svelte";
    import {createEventDispatcher} from 'svelte/internal';

    export let title = '';
    export let subtitle = '';
    export let controls = null;
    export let sticky = false;

    const dispatch = createEventDispatcher();

    const onControlClick = (control) => {
        dispatch(control.id);
    };
</script>

<div class="page-header" class:sticky={ sticky }>
    <div class="page-header-wrapper">
        <h1>{ title }</h1>
        {#if subtitle}
            <h2>{ subtitle }</h2>
        {/if}
    </div>
    {#if controls}
        <div class="controls">
            {#each controls as control}
                {#if !control.hidden}
                    <span class="control { control.class || '' }">
                        {#if control.link}
                            <A href="{ control.link }" class="btn btn-primary" title="{ control.tip }">
                                {#if control.icon}
                                    <AppIcon icon="{ control.icon }" size="16" strokeWidth="2" inline/>
                                {/if}
                                { control.name }
                            </A>
                        {:else}
                            <button class="btn" class:btn-primary={ !control.active } class:btn-danger={ control.active }
                                    title="{ control.tip }" on:click={ () => onControlClick(control) }>
                                {#if control.icon}
                                    <AppIcon icon="{ control.icon }" size="16" strokeWidth="2" inline/>
                                {/if}
                                { control.name }
                            </button>
                        {/if}
                    </span>
                {/if}
            {/each}
        </div>
    {/if}
</div>

<style>
    .page-header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        padding: 0.5rem 0;
        margin: -0.5rem 0 2.5rem 0;
    }

    .page-header h1, .page-header h2 {
        font-weight: normal;
        color: #666;
    }

    .page-header h1 {
        font-size: 1.6rem;
        margin-bottom: 0;
    }

    .page-header h2 {
        font-size: 1.1rem;
        margin-top: 5px;
    }

    .page-header.sticky {
        position: sticky;
        top: 50px;
        background: #f2f6f8;
        z-index: 9000;
    }

    .controls .control {
        margin-left: 5px;
    }
</style>